<template>
  <div class="resource-mall">
    <van-dropdown-menu active-color="#0089FF">
      <van-dropdown-item v-model="categoryCode" :options="categoryList" @change="findDistributionGoods"/>
      <van-dropdown-item v-model="branchId" :options="supplierList" @change="findDistributionGoods"/>
    </van-dropdown-menu>
    <form action="/">
      <van-search
        v-model="searchName"
        show-action
        shape="round"
        placeholder="请输入输入商品名称"
        @search="onSearch"
      />
    </form>
    <van-pull-refresh v-model="isLoading" :head-height="80" @refresh="onRefresh">
      <van-list
          v-model="loading"
          :finished="finished"
          @load="onLoad"
          finished-text="已经到头了~"
        >
        <ul class="product-list">
          <li v-for="item in list" :key="item.id">
            <div class="list-img">
              <img :src="item.pic" alt="">
            </div>
            <div class="list-text">
              <p class="text-top">
                {{item.name}}
              </p>
              <div class="text-bottom">
                <div class="text-tip">
                  <p class="owner">{{item.serviceName}}</p>
                  <p><span class="cny"></span><span class="price">{{item.price}}</span></p>
                </div>
                <div class="text-handle">
                  <span>推广招生</span>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
export default {
  name:'ResourceMall',
  data(){
    return{
      isLoading:false, //下拉刷新加载
      loading:false,  //上滑加载
      finished:true,
      searchName:'fdsfd',
      categoryCode: 0, //分类code
      branchId: 0, //机构id
      list:[{
        price:'1232323',
        pic:'https://temp.im/192x144',
        name:'育婴师上门必备技能课2颁发高风刀霜剑风扇电机',
        serviceName:'伟东培训机构提供'
      }],
      //课程分类
      categoryList:[{
        "code": 0,
        "id": 0,
        "name": "课程分类"
      },{
        "code": 1,
        "id": 1,
        "name": "发送到发顺丰大是大非"
      },{
        "code": 2,
        "id": 2,
        "name": "发斯蒂芬斯蒂芬"
      }],
      //供应商
      supplierList:[{
         "branchId": 0,
         "branchName": "课程供应商"
      },{
         "branchId": 1,
         "branchName": "fdfsdfsdf"
      },{
         "branchId": 2,
         "branchName": "发放的说法"
      }],
    }
  },
  created(){
    // this.getData();
    this.findBranchList();
    this.branchGetGoodsCategoryLevelOne();
    this.findDistributionGoods();
  },
  methods:{
    // 搜索
    onSearch(){
      this.findDistributionGoods();
    },
    //上拉加载
    onLoad(){
      this.findDistributionGoods();
    },
    // 下拉刷新
    onRefresh(){
      this.findDistributionGoods();
    },
    // 分类
     branchGetGoodsCategoryLevelOne(){
       this.$api.resourceMall.branchGetGoodsCategoryLevelOne().then(res=>{
         this.categoryList = JSON.parse(JSON.stringify(this.categoryList).replace(/name/g, 'text').replace(/code/g, 'value'))
        //  if(res.data){
        //    this.categoryList = JSON.parse(JSON.stringify(res.data).replace(/name/g, 'text').replace(/id/g, 'value'))
        //  }
       })
     },
    findBranchList(){
      this.$api.resourceMall.findBranchList().then(res=>{
        this.supplierList = JSON.parse(JSON.stringify(this.supplierList).replace(/branchName/g, 'text').replace(/branchId/g, 'value'))
        // if(res.data){
        //   this.supplierList = JSON.parse(JSON.stringify(res.data.list).replace(/branchName/g, 'text').replace(/branchId/g, 'value'))
             this.isLoading = false;
             this.loading = false;
            if (this.list.length >= res.data.total) {
              this.finished = true;
            }
        // }
      })
    },
    // 课程列表
    findDistributionGoods(){
      const params = {
        pageNum:1,
        pageSize:10
      }
      const data = {
        branchId:this.branchId, //机构Id
        categoryCode:this.categoryCode, //分类code
      }
      this.$api.resourceMall.findDistributionGoods(params,data).then(res=>{
        if(res.data){
          // this.list = res.data;
        }
      })
    },
  }
}
</script>
<style lang="stylus" scoped>
 @import "../asset/css/index.styl"
</style>
